import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 42144 38264"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:610.783;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313120304">
        <path
          d="M305 306h41525v3037H305z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 563.442,
            strokeLinecap: "round",
          }}
        />
        <path
          d="M4572 21638c2845 5902 2845 16124 2845 16124-444 0-444 197-888 197s-444-197-887-197c-444 0-444 197-888 197s-444-197-889-197c-443 0-443 197-887 197-445 0-445-197-890-197-446 0-446 197-891 197-446 0-446-197-892-197V3338"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 563.442,
            strokeLinecap: "round",
          }}

        />
        <path
          d="M15741 3610S11608 16307 4542 21561c0 0-2481-483-4237-2492M41839 37663V3240M37572 21540c-2845 5901-2845 16123-2845 16123 444 0 444 198 888 198s444-198 887-198c444 0 444 198 888 198s444-198 889-198c443 0 443 198 887 198 445 0 445-198 890-198s445 198 891 198 446-198 892-198M26688 3338s3848 12871 10914 18124c0 0 2481-482 4237-2491M7751 36693c962 0 962 523 1924 523 963 0 963-523 1926-523 962 0 962 523 1924 523 964 0 964-523 1927-523s963 523 1925 523c964 0 964-523 1927-523s963 523 1926 523c962 0 962-523 1923-523 963 0 963 523 1926 523 964 0 964-523 1927-523s963 523 1926 523c965 0 965-523 1930-523 966 0 966 523 1932 523s966-523 1933-523M11248 36693v-5828M15392 36693v-7545M19147 24712v-2197M19147 36693v-9480M23161 23456V13182M23161 33779v-8753M26981 36693V24712M30801 36693v-5991M2921 21141v1673M38998 21085v1729"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 563.442,
            strokeLinecap: "round",
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
